import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RsGridComponent } from './rs-grid.component';
import { GridModule } from '@progress/kendo-angular-grid';
import { NglDropdown } from 'ng-lightning';
import { NglModule   } from 'ng-lightning';
import { RouterModule } from '@angular/router';
import { ChartModule } from '../../../common/component/chart/chart.module';
import { ReportDialogModule } from '../../../common/component/report-dialog/report-dialog.module';

@NgModule({
    imports: [
        CommonModule,
        GridModule,
        NglModule,
        RouterModule,
        ChartModule,
        ReportDialogModule
    ],
    declarations: [RsGridComponent],
    exports: [RsGridComponent, NglDropdown],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class RsGridModule { }
